var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteInterstate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.847 55.125C477.222 43.5 465.849 36 454.6 39.25C436.352 44.25 416.855 47.125 396.482 47.125C347.364 47.125 302.994 31.125 270.373 5C266.124 1.625 261.124 0 256 0C250.876 0 245.876 1.625 241.627 5C209.131 31.125 164.636 47.125 115.518 47.125C95.145 47.125 75.648 44.25 57.4 39.125C46.151 36 34.778 43.5 31.153 55.125C-5.842 175.125 9.406 410.375 256 512C502.594 410.375 517.842 175.125 480.847 55.125ZM256 441.875C131.266 380.875 88.021 279.5 80.772 192H431.228C423.979 279.5 380.734 380.875 256 441.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteInterstate);
export default __webpack_public_path__ + "static/media/route-interstate.46a8f1e39592fff4144145a2a50c9f1b.svg";
export { ForwardRef as ReactComponent };